/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Blocks_AriaInputs */

const vi_shop_home_blocks_aria = /** @type {(inputs: Shop_Home_Blocks_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các khối trang chủ`)
};

/**

* @param {Shop_Home_Blocks_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_blocks_aria = /** @type {((inputs?: Shop_Home_Blocks_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Blocks_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_blocks_aria(inputs)
});